import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Analytics, logEvent } from '@jfw/angular/shared/firebase/analytics';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';

// EXT-5255: GA4's own Enhanced Measurement "history change" listener races
// against Angular's title update and often captures the generic app title
// instead of the page-specific one. Firing page_view explicitly here, from
// NavigationEnd, reads Title.getTitle() at a point Angular guarantees is
// after SEOResolver has already set it.
@Injectable({ providedIn: 'root' })
export class PageViewTrackingService {
  private router = inject(Router);
  private titleService = inject(Title);
  private analytics = inject(Analytics);
  private document = inject(DOCUMENT);

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects),
        distinctUntilChanged(),
      )
      .subscribe((urlAfterRedirects) => {
        logEvent(this.analytics, 'page_view', {
          page_title: this.titleService.getTitle(),
          page_path: urlAfterRedirects,
          page_location: this.document.location.href,
        });
      });
  }
}
